import React from "react";
import BacktoTopCom from "./BackToTopCom";
import Layouts from "./Layouts";

export default function InnerPageDefaultLayout({
  background,
  children = "",
  pageTitle = "" ,
  breadcrumbs = [],
  metaTag = "",
}) {
  return (
    <Layouts background={background} pageTitle={pageTitle} breadcrumbs={breadcrumbs} metaTag={metaTag}>
      {children && children}
      <BacktoTopCom />
    </Layouts>
  );
}
